import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSurveyContext } from '../context/SurveyContext';

// TODO: Review this component. Certain effects are not working as expected and might be redundant.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const { surveyState } = useSurveyContext();

  const SCROLL_TOP_OFFSET = 0;
  
  // Helper function to scroll to top with consistent behavior
  const scrollToTop = () => {
    window.scrollTo({
      top: SCROLL_TOP_OFFSET,
      left: 0,
      behavior: 'smooth'
    });
  };
  
  // Scroll to top when pathname changes (route navigation)
  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  // Scroll to top when survey step changes (state navigation)
  useEffect(() => {
    if (surveyState.currentStep) {
      scrollToTop();
    }
  }, [surveyState.currentStep]);

  // Scroll to top when survey section changes
  useEffect(() => {
    if (surveyState.currentSection !== undefined) {
      scrollToTop();
    }
  }, [surveyState.currentSection]);

  // Scroll to top when survey subsection changes
  useEffect(() => {
    if (surveyState.currentSubsection !== undefined) {
      scrollToTop();
    }
  }, [surveyState.currentSubsection]);

  // Scroll to top when break pages are displayed
  // This handles: break-1, break-2, and any other break-related steps
  useEffect(() => {
    if (surveyState.currentStep && surveyState.currentStep.includes('break')) {
      scrollToTop();
    }
  }, [surveyState.currentStep]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
